import {
    ExperienceContainer,
    ExperienceH1,
    ExperienceWrapper,
    ExperienceCard,
    ExperienceIcon,
    ExperienceH2,
    ExperienceH3,
    ExperienceP
} from './ExperienceElems'

export default function ExperienceElems() {
  return (
            <ExperienceContainer id='experience'>
            <ExperienceH1>My Hands-on Experience</ExperienceH1>
            <ExperienceWrapper>
                <ExperienceCard>
                    <ExperienceIcon src='/images/humm-logo.svg'/>
                    <ExperienceH2>Humm Group</ExperienceH2>
                    <ExperienceH3>Software QA Engineer</ExperienceH3>
                    <ExperienceP>Conducted ad-hoc and regression testing on humm group's legacy customer portal and used C# to aid backend management of log systems and customer support functionality.</ExperienceP>
                </ExperienceCard>
                <ExperienceCard>
                <ExperienceIcon src='/images/compclub.svg'/>
                    <ExperienceH2>CSESoc CompClub</ExperienceH2>
                    <ExperienceH3>Internal Subcommittee Member</ExperienceH3>
                    <ExperienceP>Organsing workshops for Australian high school students focused on a variety of topics in computer science. Helped host multiple workshops of 50+ students in size during the winter.</ExperienceP>
                </ExperienceCard>
                <ExperienceCard>
                <ExperienceIcon src='/images/umcg.svg'/>
                    <ExperienceH2>UMCG</ExperienceH2>
                    <ExperienceH3>Consultant</ExperienceH3>
                    <ExperienceP>Consulting program spanned over three months that focused on developing a marketing and financial toolkit to ultimately develop a business strategy for Headspace.</ExperienceP>
                </ExperienceCard>
            </ExperienceWrapper>

            <br/><br/><br/><br/><br/>

            <ExperienceH1>Project Feature</ExperienceH1>
            <ExperienceWrapper>
                <ExperienceCard>
                    <a href="https://tylergan-portfolio.netlify.app/"><ExperienceIcon src='/images/personal-portfolio.jpg'/></a>
                    <ExperienceH2>Personal Project</ExperienceH2>
                    <ExperienceP>My first ReactJS project, which happens to be this very personal website you are viewing.</ExperienceP>
                </ExperienceCard>
                <ExperienceCard>
                    <a href="https://main--tylergan-fighting-game.netlify.app/"><ExperienceIcon src='/images/fightingGame.png'/></a>
                    <ExperienceH2>Fighting Game</ExperienceH2>
                    <ExperienceP>Another project that I learned to make on YouTube. Made with a few improvements, I hope to add more, like more characters, later.</ExperienceP>
                </ExperienceCard>
                <ExperienceCard>
                    <a href="https://github.com/tylergan/pacmangame"><ExperienceIcon src='/images/pacman-game.jpg'/></a>
                    <ExperienceH2>Pacman Game</ExperienceH2>
                    <ExperienceP>A fully functional Pacman game, without the sound... so, almost fully functional?</ExperienceP>
                </ExperienceCard>
            </ExperienceWrapper>
        </ExperienceContainer>
  )
}
